const isI18nEnabled = (orgId) => {
  //Add case and id for organization and return false if internationalization is not enabled
  switch (orgId) {
    case 2: // Brookline Bank Dynamic Organization (Example)
      return false;
    case 94: // BCH Leaders
      return false;
    default:
      return true;
  }
};

export default isI18nEnabled;
